import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { functions } from '../functions/_functions';
import { withTheme } from '../core/theming';
import { PropTypesRepo } from '../functions/_propTypes';

const animation = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

const Loader = withTheme(styled.span`
  background-size: 200px 100%;
  background-repeat: no-repeat;
  display: inline-block;
  line-height: 1;
  background-color: ${({ theme: { skeleton } }) => skeleton.baseColor};
  background-image: ${({ theme: { skeleton } }) => `linear-gradient(
    90deg, ${skeleton.baseColor}, ${skeleton.hightlightColor}, ${skeleton.baseColor}
  )`};
  animation: ${animation} ease-in-out ${({ theme: { skeleton } }) => `${skeleton.duration}s`} infinite;
  ${(props) => functions.findRoundedDirection(props.rounded, props.theme.rounded)};
  ${(props) => functions.makeResponsive('width', props.w)};
  ${(props) => functions.makeResponsive('height', props.h)};
`);

Loader.propTypes = {
  theme: PropTypes.shape({
    skeleton: PropTypes.shape({}),
  }),
  rounded: PropTypesRepo.rounded,
  w: PropTypesRepo.w,
  h: PropTypesRepo.h,
};

Loader.defaultProps = {
  rounded: 'sm',
  w: '100%',
  h: 'auto',
};

const Skeleton = ({ count, w, h, rounded }) => {
  const elements = [];
  for (let i = 0; i < count; i += 1) {
    elements.push(<Loader w={w} h={h} rounded={rounded} />);
  }
  return <span>{elements}</span>;
};

Skeleton.propTypes = {
  rounded: PropTypesRepo.rounded,
  w: PropTypesRepo.w,
  h: PropTypesRepo.h,
  count: PropTypes.number,
};

Skeleton.defaultProps = {
  rounded: 'sm',
  w: '100%',
  h: 'auto',
  count: 1,
};

export default withTheme(Skeleton);
